import React, {useEffect} from 'react';
import { HelpHeader, HelpInfoContainer, NeedHelpContainer } from './styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import NeedHelpRow from './need-help-row';
import {ga4Event} from "../../../utils/google-analytics-4";

export const NeedHelp = (props) => {
  const selfServiceItems = props.state.customerSlice.selfServiceConfigurations.selfServiceItem;

  useEffect(() => {
    ga4Event({category: 'need-help', action: 'page-view'});
  }, []);

  return (
    <>
      <Helmet>
        <title>Need Help</title>
      </Helmet>
      <NeedHelpContainer>
        <HelpHeader>Help Information</HelpHeader>
        <HelpInfoContainer>
          {selfServiceItems.map((selfServiceItem) => {
            return <NeedHelpRow key={selfServiceItem.id} {...selfServiceItem} />;
          })}
        </HelpInfoContainer>
      </NeedHelpContainer>
    </>
  );
};

NeedHelp.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      customerSlice: PropTypes.object,
    }),
  }),
};

const mapStateToProps = (state) => ({
  isLoading: state.customerSlice.isLoading,
  state,
});

export default connect(mapStateToProps)(NeedHelp);
